import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAccountType } from '@hooks/useAccountType';
import { useBankName } from '@hooks/useBankName';
import { hideLoading, showLoading } from '@store/common/actions';

const useAddFundsOut = () => {
  const dispatch = useDispatch();
  const { accountTypes } = useAccountType();
  const { bankNames } = useBankName();

  useEffect(() => {
    if (accountTypes.length > 0 && bankNames.length > 0) {
      dispatch(hideLoading());
    } else {
      dispatch(showLoading());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountTypes, bankNames]);

  return {
    accountTypes,
    bankNames,
  };
};

export default useAddFundsOut;
